import type { AutopilotGoal, Campaign, Optimization, OptimizationType, ResultMetric } from '../../demo/types'

export type NeedsHumanDestination = 'settings' | 'link'

export function needsHumanDestination(target: string): NeedsHumanDestination {
  return target === '更新商品链接' ? 'link' : 'settings'
}

export function latestAdjustment(items: Optimization[], types: OptimizationType[]): Optimization | null {
  return items.find((item) => !item.undone && types.includes(item.type)) ?? null
}

export function targetForGoal(campaign: Campaign, goal: AutopilotGoal, improveRatio: number): number | null {
  if (goal === 'lower_cpa') {
    const cpa = campaign.metrics.cpa
    return cpa && cpa > 0 ? Math.floor(cpa * (1 - improveRatio)) : null
  }
  const current = goal === 'more_orders' ? campaign.orders : campaign.impressions
  return current > 0 ? Math.ceil(current * (1 + improveRatio) / 100) * 100 : null
}

export function parseTarget(value: string): number | null {
  const normalized = value.replaceAll(',', '').trim()
  if (!normalized) return null
  const parsed = Number(normalized)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null
}

export function formatTargetInput(value: number | null): string {
  return value === null || value <= 0 ? '' : value.toLocaleString('en-US')
}

export function formatGoalTarget(goal: AutopilotGoal, target: number): string {
  const number = target.toLocaleString('en-US')
  if (goal === 'lower_cpa') return `$${number}`
  return `${number} ${goal === 'more_orders' ? '单' : '次'}`
}

export function fmtDelta(value: number): string {
  const rounded = Math.round(value * 100)
  if (rounded > 0) return `+${rounded}%`
  if (rounded < 0) return `−${Math.abs(rounded)}%`
  return '0%'
}

export function thirdLabelForMetric(metric: ResultMetric): string {
  return metric === 'orders' ? '每单成本' : '展示次数'
}

export function isImprovement(thirdKey: 'cpa' | 'impressions', value: number): boolean {
  return thirdKey === 'cpa' ? value < 0 : value > 0
}

export function variantBase(campaignId: string): number {
  const match = /^c-new-(\d+)$/.exec(campaignId)
  return match ? Number(match[1]) % 3 : 0
}

export function pickVariant<T>(items: T[], base: number, counter: number): T {
  if (items.length === 0) throw new Error('Cannot pick a variant from an empty list')
  return items[((base + counter) % items.length + items.length) % items.length]!
}

export function variantBatch(campaignId: string, counter: number): string {
  const task = /^c-new-(\d+)$/.exec(campaignId)?.[1]
    ?? String([...campaignId].reduce((sum, character) => sum + character.charCodeAt(0), 0) % 97 + 1)
  return `${task}-${String(counter + 1).padStart(2, '0')}`
}
